export default {
  introduce: {
    title: '推出全新收费模式',
    cost: '根据素材展示量计费',
    limit: '限量前 50 名',
    gift: '立即填写信息申请新人大礼包吧',
    describe:
      '前 50 名激活账号并完成首充的客户将获得新用户大礼包，其中包括 Mindworks 团队提供的免费素材制作机会 x2',
  },
  form: {
    name: '请输入姓名',
    email: '请输入电子邮箱',
    validate: '电子邮箱格式错误',
    remark: '请留言给我们吧',
    send: '立即申请',
    success: '感谢您联络我们，将很快跟您联系！',
  },
  suggest: {
    chargMode: {
      title: '收费模式',
      describe: '根据 Mintegral 渠道的素材展示量计费',
    },
    cpmPrice: {
      title: 'CPM 价格',
      describe: '单条素材每千次展示收费 0.5 美元',
    },
    cappMechanism: {
      title: '封顶机制',
      describe: '每条素材费用封顶 800 美元并不再继续累计费用',
    },
    minRecharge: {
      title: '最低充值',
      describe:
        '最低金额 800 美元，这是一个预付款项，用于保证广告投放的持续性和稳定性。',
    },
  },
  problem: {
    title: '常见问题',
    question1: '广告费用计费模式是所有渠道都适合吗？',
    question2: 'CPM费用怎么计算的？',
    question3: '如果超过了800美金会怎么样？',
    question4: '最低需要充值多少？账单如何计算？',
    main: {
      content1: '我们的广告费用计费模式基于素材展示量，目前仅支持 Mintegral。',
      content2:
        '单条素材每千次展示收费0.5美元。即，每当单条广告素材被展示1000次，将收取0.5美元的费用。',
      content3:
        '为了保护广告主的利益，我们针对单个素材设置了一个最高费用上限。当单条广告素材从上线开始的展示量超过1,600,000次时，也就是每条素材费用封顶 800 美元并不再继续累计费用。这意味着无论展示量多高，单个素材的费用都不会超过封顶金额。',
      content4:
        '为了使用我们的广告服务，单个广告主需要充值的最低金额为800美元。这是一个预付款项，用于保证广告投放的持续性和稳定性。',
      example: {
        describe: '举例说明：',
        title:
          '假设您同时投放了多条的可玩素材，并分别在不同月份开始投放。以下是每个月的账单情况：',
        October: {
          title: '10月份分别制作素材 ABCD 并开始投放：',
          materialA: '素材A：500,000次展示',
          materialB: '素材B：45,000次展示',
          materialC: '素材C：600,000次展示',
          materialD: '素材D：550,000次展示',
          cost: '10 月费用计算：',
          materialACost:
            '素材A费用：500,000次 ÷ 1000次 × 0.5美元/CPM = 250美元',
          materialBCost:
            '素材B费用：45,000 次 ÷ 1000次 × 0.5美元/CPM = 22.5美元',
          materialCCost:
            '素材C费用：600,000次 ÷ 1000次 × 0.5美元/CPM = 300美元',
          materialDCost:
            '素材D费用：55,000 次 ÷ 1000次 × 0.5美元/CPM = 27.5美元',
          totalCost:
            '10 月总费用：250美元 + 22.5美元 + 300美元 + 27.5美元 = 600 美元',
        },
        November: {
          title:
            '11月份素材 AB 仍然继续投放，CD 已经停止投放，新制作 EF 开始投放：',
          materialA: '素材 A：1,200,000次展示',
          materialB: '素材 B：58,000次展示',
          materialE: '素材 E：53,000次展示',
          materialF: '素材 F：48,000次展示',
          cost: '11 月费用计算：',
          materialACost:
            '素材 A 费用：由于素材 A 从 10 月开始累计展示，10 月加 11 月的展示数已经超过 160 万次展示（ 50,000 + 1,200,000 = 1,700,000）所以本月费用为(1,600,000 - 500,000) 次 ÷ 1000次 × 0.5美元/CPM = 550 美元',
          materialBCost:
            '素材 B 费用：58,000次 ÷ 1000次 × 0.5美元/CPM = 29美元',
          materialECost:
            '素材 E 费用：53,000次 ÷ 1000次 × 0.5美元/CPM = 26.5美元',
          materialFCost:
            '素材 F 费用：48,000次 ÷ 1000次 × 0.5美元/CPM = 24美元',
          totalCost:
            '11 月总费用：550 美元 + 29美元 + 26.5美元 + 24美元 = 629.5 美元',
        },
        tips: '*请注意，在每个月份的费用计算中，我们分别考虑了各自素材的展示量，并将每个素材的费用相加得出总费用。封顶机制适用于单个素材，确保其费用不会超过单个封顶金额。',
      },
    },
  },
  bottom: '活动解释权归 Mindworks、Mintegral 所有',
}
